<template>
  <div class="header">
    <!-- <div class="header-left" @click="toPage(backPage)" v-if="backPage != ''">
      <van-icon class="header-left-icon" name="arrow-left" />
    </div> -->
    <div class="header-center" v-text="titleContent"></div>
    <!-- <div class="header-right">
      <img class="header-img" src="../assets/images/Header_logo.png" alt />
    </div> -->
  </div>
</template>

<script>
import { MOBILE_URL, STATUS_CODE_OK } from "@/config";
import store from "@/store";
import { getUserParm } from "@/api/motionFocus";
export default {
  name: "comHeader",
  props: {
    title: {
      type: String
    },
    backPage: {
      type: String
    }
  },
  data() {
    return {
      titleContent: this.title,
      listPagesShow: false
    };
  },
  methods: {
    toPage(backPage) {
      if (backPage && backPage === "mobile") {
        var url = MOBILE_URL;
        this.gotoMobileParts(url)
      } else {
        this.$router.back();
      }
    },
    async gotoMobileParts(url) {
      let { data } = await getUserParm({
        userCode: store.getters.userCode
      });
      if (data.resultStatusCode === STATUS_CODE_OK) {
        var tempUrl = url + '?userName=' + data.encryptedUserInfo;
        window.location.href = tempUrl;
      }
    }
  }
};
</script>
<style lang='scss'>
.header {
  height: 50px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  color: white;
  // background: linear-gradient(to right, #da291c 60%, #f2404d);
  background: #da291c;
  .header-left {
    font-size: 14px;
    .header-left-icon {
      padding: 10px 20px;
      font-size: 20px;
      color: white;
    }
  }
  .header-center {
    // position: absolute;
    // top: 0;
    // left: 75px;
    // right: 75px;
    font-weight: bold;
    padding: 10px 20px;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    font-size: 18px;
  }
  .header-right {
    position: absolute;
    right: 0px;
    padding: 8px 20px 0px 20px;
    .header-img {
      width: 28px;
    }
  }
}
</style>